import { Box, Button, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getUserFollowers, getUserFollowing } from '../../../actions/profile';
import theme from '../../../muiTheme';
import UserAvatar from '../../UserAvatar/UserAvatar';
import styles from './styles';
import { FiX, FiArrowLeft} from "react-icons/fi";

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const FollowersView = ({profile = null, index = 0, onClose}) => {

    const [swiper, setSwiper] = useState(null); 
    const [value, setValue] = useState(0);
    const [followersPage, setFollowersPage] = useState(1);
    const [followingPage, setFollowingPage] = useState(1);
    const [followers, setFollowers] = useState([]);
    const [following, setFollowing] = useState([]);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const dispatch = useDispatch(); 

    useEffect(()=>{

        if(index){
            setValue(index);

            if(swiper){
                swiper.slideTo(index);
            }
        }

    }, [index]);

    useEffect(()=>{

        if(profile._id){

            //fetch followed and following users for id
            dispatch(getUserFollowers(profile._id, followersPage, (error, res) => {

                console.log('fetched followers: ', res);

                setFollowers(res.followers); 

            })); 

            dispatch(getUserFollowing(profile._id, followingPage, (error, res) => {

                console.log('fetched following: ', res);
                setFollowing(res.following);
            })); 
        }

    }, [profile]);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);

        console.log('Tab changed, value: ', newValue, ' swiper: ', swiper);

        if(swiper){
            swiper.slideTo(newValue);
        }
        
    };

    const handleTabChangeIndex = (index) => {
        setValue(index);
    };

    const handleClose = () => {

        if(typeof onClose === 'function'){

            onClose();
        }
    }

    const loadMoreFollowers = () => {

        dispatch(getUserFollowers(profile._id, followersPage++, (error, res) => {

            console.log('fetched followers: ', res);

            setFollowers([
                ...followers,
                res.followers
            ]); 

            setFollowersPage(prevValue => prevValue++);

        })); 

    }

    const loadMoreFollowing = () => {

        dispatch(getUserFollowing(profile._id, followingPage++, (error, res) => {

            console.log('fetched following: ', res);

            setFollowing([
                ...following,
                res.following
            ]); 

            setFollowingPage(prevValue => prevValue++);

        })); 
    }


    return (
        <Box
        
            sx={{
                display: 'flex',
                position: 'relative',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                maxHeight: '100vh',
                width: '800px',
                maxWidth: '100vw',
                paddingTop: '0px',
                boxSizing: 'border-box',
                height: '800px',
                background: 'white',
                borderRadius: '10px',
                overflowY: 'scroll',
                [theme.breakpoints.down('sm')]: {
                    maxHeight: '100vh',
                    height: '100vh',
                    paddingTop: '0px',
                    borderRadius: '0px'
                }

            }}
        >

                <Box
                    sx={styles.tabsContainer}
                >

                    <Button 
                        className='follow-close-button' 
                        sx={styles.closeButton} 
                        variant={isMobile ? 'inverted' : 'main'}
                        onClick={handleClose}>

                            {
                                isMobile ? 

                                <FiArrowLeft style={{fontSize: '28px'}} />

                                :

                                <FiX />
                            }
                         
                    </Button>

                    <img src={profile.profileImage} alt='profileimage' style={styles.tabsAvatar}/> 
                    
                    <Tabs
                        value={value}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                    >
                        <Tab label="Following" {...a11yProps(0)} />
                        <Tab label="Followers" {...a11yProps(1)} />
                    </Tabs>
                    
                </Box>

                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        background: theme.palette.background.container,
                        zIndex: '2'
                    }}
                >

                    <Box
                        className='swiper-container'
                        sx={styles.swiperContainer}
                    >

                        <Swiper

                            className='profile-swiper'
                            style={styles.profileSwiper}
                            onSlideChange={(swiperObj) => setValue(swiperObj.realIndex) }
                            onSwiper={setSwiper}
                        >

                            <SwiperSlide
                                style={styles.swiperSlide}
                            >

                                <Box
                                    sx={styles.swiperSlideContentBox}
                                >

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexWrap: 'no-wrap',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            maxWidth: '100%',
                                            width: '100%'
                                            
                                        }}
                                    >

                                        {following?.map((account, index) => {

                                            let output = (
                                                <Box 
                                                    key={account.name+index}
                                                    sx={{
                                                        margin: '10px',
                                                        background: theme.palette.faint,
                                                        borderRadius: '15px',
                                                        padding: '20px',
                                                        width: '90%',
                                                        boxSizing: 'border-box',
                                                        transition: '0.3s',
                                                        '&:hover': {
                                                            background: theme.palette.lightGray,
                                                        },
                                                        
                                                    }}
                                                >

                                                    <UserAvatar 
                                                        url={`/profile/${account._id}`} 
                                                        imageURL={account.profileImage} 
                                                        name={account.name} 
                                                        bio={account.bio} 
                                                        //follow={follow} 
                                                        verified={account.verified} 
                                                        // imageSx={imageSx} 
                                                        nameSx={styles.nameSx}
                                                    />

                                                    

                                                </Box>
                                            );

                                            return output;
                                        })}

                                        {
                                            following.length < profile.followingCount &&

                                            <Button variant='main' onClick={loadMoreFollowing}>
                                                Load More
                                            </Button>
                                        }

                                    </Box>

                                </Box>

                                

                                
                            </SwiperSlide>

                            <SwiperSlide
                                style={styles.swiperSlide}
                            >
                                <Box
                                    sx={styles.swiperSlideContentBox}
                                >

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexWrap: 'no-wrap',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            maxWidth: '100%',
                                            width: '100%'
                                        }}
                                    >

                                        {followers?.map((account, index) => {

                                            let output = (
                                                <Box 
                                                    key={account.name+index}
                                                    sx={{
                                                        margin: '10px',
                                                        background: theme.palette.faint,
                                                        borderRadius: '15px',
                                                        padding: '20px',
                                                        width: '90%',
                                                        boxSizing: 'border-box',
                                                        transition: '0.3s',
                                                        '&:hover': {
                                                            background: theme.palette.lightGray,
                                                        },
                                                        
                                                    }}
                                                >

                                                    <UserAvatar 
                                                        url={`/profile/${account._id}`} 
                                                        imageURL={account.profileImage} 
                                                        name={account.name} 
                                                        bio={account.bio} 
                                                        //follow={follow} 
                                                        verified={account.verified} 
                                                        // imageSx={imageSx} 
                                                        nameSx={styles.nameSx}
                                                    />

                                                    

                                                </Box>
                                            );

                                            return output;
                                        })}

                                        {
                                            followers.length < profile.followerCount &&

                                            <Button variant='main' onClick={loadMoreFollowers}>
                                                Load More
                                            </Button>
                                        }

                                        

                                    </Box>

                                </Box>
                            
                            </SwiperSlide>


                        </Swiper>

                        
                    </Box>
                </Box>
                

                
        </Box>
    );
}

export default FollowersView; 